export default "__VITE_ASSET__DaxtLQWl__"